import { render, staticRenderFns } from "./LevellingPageShell.vue?vue&type=template&id=680f1b85&scoped=true"
import script from "./LevellingPageShell.vue?vue&type=script&setup=true&lang=js"
export * from "./LevellingPageShell.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LevellingPageShell.vue?vue&type=style&index=0&id=680f1b85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f1b85",
  null
  
)

export default component.exports